export const LOCAL_FILTER_FIELDS = [
    {
        label: "Item Code",
        type: "text",
        name: "itemCode",
    },
    {
        label: "Item Name",
        type: "text",
        name: "itemName",
    },
    {
        label: "Location Code",
        type: "text",
        name: "locationCode",
    }
]